// Tracks demo tours seen in this browser session across Turbo navigations.
export const seenTours = new Set()

const demoStorageKey = "astrolabe-demo-tour-state"

function demoMode() {
  return document.querySelector('meta[name="demo-mode"]')?.content === "true"
}

function getDemoState() {
  try { return JSON.parse(sessionStorage.getItem(demoStorageKey) || "{}") }
  catch { return {} }
}

function updateDemoState(tourName, status) {
  const state = getDemoState()
  state[tourName] = status
  try {
    sessionStorage.setItem(demoStorageKey, JSON.stringify(state))
  } catch {
    // seenTours remains the in-memory fallback when browser storage is unavailable.
  }
}

export function getTutorialState() {
  return demoMode() ? getDemoState() : {}
}

export function updateTutorialStateMeta(tourName, status) {
  if (demoMode()) {
    updateDemoState(tourName, status)
  }
}

export function markTourDone(tourName, action) {
  const status = action === "complete" ? "completed" : "skipped"
  seenTours.add(tourName)
  updateTutorialStateMeta(tourName, status)
}
